import { jwtDecode } from "jwt-decode";

export const parseJwt = (token: string) => {
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
};
